import { render, staticRenderFns } from "./Character.vue?vue&type=template&id=9a4c1d5a&lang=pug&"
import script from "./Character.vue?vue&type=script&lang=ts&"
export * from "./Character.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports